import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      /* ACESSO ADMINISTRADOR */
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
        roles: [3],
      },
      children: [
        {
          name: 'Diagnósticos',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'CCSxCPP',
          path: 'analise-ccs-cpp',
          component: () => import('@/views/dashboard/AnaliseCcsCpp'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Listar Consultores',
          path: 'consultores/listar-consultores',
          component: () =>
            import('@/views/dashboard/consultores/ListarConsultores'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Formulário Consultores',
          path: 'consultores/formulario-consultores',
          component: () =>
            import('@/views/dashboard/consultores/FormularioConsultores'),
        },
        {
          name: 'Listar Agroindustrias',
          path: 'agroindustrias/listar-agroindustrias',
          component: () =>
            import('@/views/dashboard/agroindustrias/ListarAgroindustrias'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Formulário Agroindustrias',
          path: 'agroindustrias/formulario-agroindustrias',
          component: () =>
            import('@/views/dashboard/agroindustrias/FormularioAgroindustrias'),
        },
        {
          name: 'Relatório Diagnósticos',
          path: 'relatorios/produtores',
          component: () =>
            import('@/views/dashboard/relatorios/RelatorioProdutores'),
        },
        {
          name: 'Relatório de Fazendas',
          path: 'relatorios/fazendas',
          component: () =>
            import('@/views/dashboard/relatorios/RelatorioFazendas'),
        },
      ],
    },

    /* ACESSO AGROINDUSTRIA */
    {
      name: 'Painel da Agroindústria',
      path: '/index-agroindustria',
      redirect: '/index-agroindustria/dashboard',
      component: () =>
        import('@/views/dashboard/painelAgroindustria/IndexAgroindustria'),
      meta: {
        requiresAuth: true,
        roles: [2],
      },
      children: [
        {
          name: 'Painel de Resultados',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Agroindustria CCSxCPP',
          path: 'analise-ccs-cpp',
          component: () => import('@/views/dashboard/AnaliseCcsCpp'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Consultores',
          path: 'consultores',
          component: () =>
            import('@/views/dashboard/consultores/ListarConsultores'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Notificações',
          path: '/index-agroindustria/notificacoes-agroindustria',
          component: () =>
            import(
              '@/views/dashboard/painelAgroindustria/NotificacoesAgroindustria'
            ),
        },
        {
          name: 'Requisitar Agroconsultor',
          path: '/index-agroindustria/requisitar-agroconsultor',
          component: () =>
            import(
              '@/views/dashboard/painelAgroindustria/RequisitarAgroconsultor'
            ),
        },
        {
          name: 'Painel Agroindustria - Diagnósticos',
          path: '/index-agroindustria/agroindustria-diagnostico',
          component: () =>
            import(
              '@/views/dashboard/painelAgroindustria/AgroindustriaDiagnostico.vue'
            ),
        },
        {
          name: 'Relatório de Diagnósticos',
          path: 'produtores',
          component: () =>
            import('@/views/dashboard/relatorios/RelatorioProdutores'),
        },
        {
          name: 'Fazendas',
          path: 'fazendas',
          component: () =>
            import('@/views/dashboard/relatorios/RelatorioFazendas'),
        },
        {
          name: 'Perfil',
          path: '/index-agroindustria/editar-conta',
          component: () => import('@/views/dashboard/pages/EditarConta'),
        },
      ],
    },

    /* ACESSO GERAL */
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/dashboard/login/Login'),
    },
    {
      name: 'RecuperarSenha',
      path: '/recuperar-senha',
      component: () => import('@/views/dashboard/login/RecuperarSenha'),
    },
    {
      name: 'AlterarSenha',
      path: '/alterar-senha/:email/:token',
      props: true,
      component: () => import('@/views/dashboard/login/AlterarSenha'),
    },
    {
      name: 'Primeiro Acesso',
      path: '/primeiro-acesso',
      props: true,
      component: () => import('@/views/dashboard/login/primeiroAcesso'),
    },
    {
      name: 'Solicitar Demonstração',
      path: '/solicitar-demonstracao',
      component: () => import('@/views/dashboard/login/SolicitarDemonstracao'),
    },
  ],
})

routes.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'))
  if (to.name === 'Login' && localStorage.getItem('user')) {
    next({
      path: '',
    })
  } else if (
    to.name !== 'Login' &&
    !localStorage.getItem('user') &&
    to.name !== 'RecuperarSenha' &&
    to.name !== 'AlterarSenha' &&
    to.name !== 'Solicitar Demonstração'
  ) {
    next({
      path: 'login',
    })
  } else if (to.path === '') {
    if (user.CodRole === 1) {
      next({
        path: '/index-consultor',
      })
    } else if (user.CodRole === 2) {
      next({
        path: '/index-agroindustria',
      })
    } else {
      next()
    }
  } else {
    if (
      to.matched[0].meta.roles &&
      !to.matched[0].meta.roles.find(el => {
        return el === user.CodRole
      })
    ) {
      if (user.CodRole === 1) {
        next({
          path: '/index-consultor',
        })
      } else if (user.CodRole === 2) {
        next({
          path: '/index-agroindustria',
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default routes
